/**
 * Pure cart utility functions — no SDK/React dependencies.
 */

export const CART_ADD = 'add';
export const CART_REMOVE = 'remove';
export const CART_SET = 'set';
export const CART_REMOVE_ITEM = 'remove-item';
export const CART_REMOVE_ALL_SELLER_ITEMS = 'remove-all-seller-items';

export const userCart = currentUser => {
  return (currentUser && currentUser.attributes.profile.publicData.cart) || [];
};

export const isFreeListing = (listing, deliveryMethod = null) => {
  const { price = null, publicData } = listing.attributes;
  const { shippingPriceInSubunitsOneItem } = publicData;
  const priceFree = price ? price.amount === 0 : true;
  const shippingFree =
    deliveryMethod === 'shipping' && shippingPriceInSubunitsOneItem
      ? shippingPriceInSubunitsOneItem === 0
      : true;
  return priceFree && shippingFree;
};

export const isFreeCart = (cartListings, deliveryMethod) => {
  const results = cartListings.map(listing => isFreeListing(listing, deliveryMethod));
  return results.indexOf(false) === -1;
};

export const cartListingsAvailableDeliveryMethods = listings => {
  const pickupEnabled = listings
    .map(listing => listing.attributes.publicData.pickupEnabled)
    .some(v => v === true);
  const shippingEnabled = listings
    .map(listing => listing.attributes.publicData.shippingEnabled)
    .some(v => v === true);
  return { pickupEnabled, shippingEnabled };
};

export const getUpdatedCart = ({ currentUser, listing, quantity, deliveryMethod, action }) => {
  quantity = parseInt(quantity);
  const listingId = listing.id.uuid;
  const authorId = listing.author.id.uuid;
  const currentCart = userCart(currentUser);
  const cart = JSON.parse(JSON.stringify(currentCart));
  const itemInCart = cart.find(i => i.id === listingId);
  const itemInCartIndex = cart.findIndex(i => i.id === listingId);

  if (action === CART_REMOVE_ALL_SELLER_ITEMS) {
    return cart.filter(i => i.authorId !== authorId);
  }
  if (itemInCart) {
    if ([CART_ADD, CART_REMOVE, CART_SET].indexOf(action) >= 0 && isNaN(parseInt(quantity))) {
      return cart;
    }
    if (action === CART_ADD) {
      itemInCart.quantity += quantity;
    }
    if (action === CART_REMOVE) {
      const newQuantity = itemInCart.quantity - quantity;
      if (newQuantity <= 0) {
        cart.splice(itemInCartIndex, 1);
      } else {
        itemInCart.quantity = newQuantity;
      }
    }
    if (action === CART_SET) {
      if (quantity <= 0) {
        cart.splice(itemInCartIndex, 1);
      } else {
        itemInCart.quantity = quantity;
      }
    }
    if (action === CART_REMOVE_ITEM) {
      return cart.filter(i => i.id !== itemInCart.id);
    }
  } else if (action === CART_ADD) {
    cart.push({ id: listingId, authorId, quantity, deliveryMethod });
  }

  return cart;
};
